import styled from 'styled-components';

export const Wrapper = styled.div `
  width: 100%;
  height: 100%;
  position:relative;
  background-color: #000000;
`;

export const Video = styled.video `
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
`